export enum PhotoOptions {
    UNKNOWN = 0,
    WITH_PHOTO = 1
}
